// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favorite-btn-CQZ09Q{color:#1d1c23}.favorite-btn-CQZ09Q .semi-button-content-right{color:#1d1c23;margin-left:4px}.favorite-btn-CQZ09Q.dark-SlWeT4 .un-collected-WPNqWl path{fill:#1d1c23}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favorite-btn": `favorite-btn-CQZ09Q`,
	"favoriteBtn": `favorite-btn-CQZ09Q`,
	"dark": `dark-SlWeT4`,
	"un-collected": `un-collected-WPNqWl`,
	"unCollected": `un-collected-WPNqWl`
};
export default ___CSS_LOADER_EXPORT___;
